import React, { useState, useEffect } from 'react'
import { makeStyles } from '@mui/styles'
import LeftSideMenu from './LeftSideMenu'
import Proxies from './Proxies'
import useMobile from './hooks/useMobile'

const useStyles = makeStyles((theme) => ({
    mainDiv: {
        display: 'flex',
        height: '100%',
    }
}))

const Shop = (props) => {
    const classes = useStyles()
    const { isMobile } = useMobile()

    // Логирование только в режиме разработки
    React.useEffect(() => {
        if (props.user?.email && process.env.NODE_ENV === 'development') {
        }
    }, [props.user?.email])

    return (
        <div className={classes.mainDiv}>
            {!isMobile && <LeftSideMenu user={props.user} active={props.active} apiClient={props.apiClient}/>}
            <Proxies user={props.user} active={props.active} apiClient={props.apiClient} setReloadData={props.setReloadData} setReloadActive={props.setReloadActive} refreshUserData={props.refreshUserData}/>
        </div>
    )
}

export default Shop